import { render, staticRenderFns } from "./management.modal.vue?vue&type=template&id=06513c6a&scoped=true&"
import script from "./management.modal.vue?vue&type=script&lang=js&"
export * from "./management.modal.vue?vue&type=script&lang=js&"
import style0 from "./management.modal.vue?vue&type=style&index=0&id=06513c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06513c6a",
  null
  
)

export default component.exports